export default "__VITE_ASSET__Cad06CkJ__"